import { render, staticRenderFns } from "./todoManage.vue?vue&type=template&id=bd1205dc&"
import script from "./todoManage.vue?vue&type=script&lang=js&"
export * from "./todoManage.vue?vue&type=script&lang=js&"
import style0 from "./todoManage.vue?vue&type=style&index=0&id=bd1205dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports